import { createAsyncAction } from 'Reducks/reduxActions';

export const getRegistrantDetailsAction = createAsyncAction('GET_REGISTRANT_DETAILS');

export function fetchRegistrantDetails(webinarKey, registrantKey, includePaymentInfo) {
  return { type: getRegistrantDetailsAction.toString(), webinarKey, registrantKey, includePaymentInfo };
}
